export const STATE_KEY = 'rosey'

const LOAD_CUSTOMERS  = 'rosey/LOAD_CUSTOMERS'
const LOAD_SESSIONS   = 'rosey/LOAD_SESSIONS'
const SET_SESSION     = 'rosey/SET_SESSION'
const APPEND_MESSAGES = 'rosey/APPEND_MESSAGES'
const SET_LOADING     = 'rosey/SET_LOADING'
const SET_ERROR       = 'rosey/SET_ERROR'
const RATE_MESSAGE    = 'rosey/RATE_MESSAGE'

export const actions = {
  loadCustomers:  (customers) => ({ type: LOAD_CUSTOMERS, customers }),
  loadSessions:   (sessions)  => ({ type: LOAD_SESSIONS, sessions }),
  setSession:     (session, messages, customer) =>
    ({ type: SET_SESSION, session, messages, customer }),
  appendMessages: (messages)  => ({ type: APPEND_MESSAGES, messages }),
  setLoading:     (loading)   => ({ type: SET_LOADING, loading }),
  setError:       (error)     => ({ type: SET_ERROR, error }),
  rateMessage:    (messageId, rating, goldenRewrite) =>
    ({ type: RATE_MESSAGE, messageId, rating, goldenRewrite }),
}

const initialState = {
  customers:       [],
  sessions:        [],
  currentSession:  null,
  currentMessages: [],
  currentCustomer: null,
  loading:         false,
  error:           null,
}

export default function roseyReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_CUSTOMERS:
      return { ...state, customers: action.customers, loading: false }
    case LOAD_SESSIONS:
      return { ...state, sessions: action.sessions, loading: false }
    case SET_SESSION:
      return { ...state, currentSession: action.session,
               currentMessages: action.messages, currentCustomer: action.customer, loading: false }
    case APPEND_MESSAGES:
      return { ...state, currentMessages: action.messages, loading: false }
    case SET_LOADING:
      return { ...state, loading: action.loading, error: null }
    case SET_ERROR:
      return { ...state, error: action.error, loading: false }
    case RATE_MESSAGE:
      return { ...state,
               currentMessages: state.currentMessages.map(m =>
                 m.id === action.messageId
                   ? { ...m, rating: action.rating, golden_rewrite: action.goldenRewrite }
                   : m) }
    default:
      return state
  }
}
